import type { BlockMultipleChoice } from 'shared-types';

type LocaleData = BlockMultipleChoice['locales'][string];

const defaultBlockData = {
  feedbackType: 'default' as const,
  isMandatory: false,
  isSingleChoice: false as const,
  noPointReductionForWrongSelections: false,
  numberOfAllowedSelectionsMax: 1,
  numberOfAllowedSelectionsMin: 0,
  pointsWeight: 2,
  requireAnswerToProceed: false,
  useResultBasedFeedback: false
};

const translatable: LocaleData['translatable'] = {
  feedback: '',
  feedbackCorrect: '',
  feedbackIncorrect: '',
  feedbackPartiallyCorrect: '',
  option_1_text: '',
  option_1_feedback: '',
  question: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  feedback: '{{ locales.translatable.feedback }}' as const,
  feedbackCorrect: '{{ locales.translatable.feedbackCorrect }}' as const,
  feedbackIncorrect: '{{ locales.translatable.feedbackIncorrect }}' as const,
  feedbackPartiallyCorrect:
    '{{ locales.translatable.feedbackPartiallyCorrect }}' as const,
  options: [
    {
      correct: false,
      feedback: '{{ locales.translatable.option_1_feedback }}' as const,
      text: '{{ locales.translatable.option_1_text }}' as const
    }
  ],
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockMultipleChoiceData: Extract<
  BlockMultipleChoice,
  { isSingleChoice?: false }
> = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockMultipleChoice['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
